import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/jobs", label: "Jobs" },
  { to: "/enquiry", label: "Job Enquiry" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact Us" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/80 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
            <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-700 via-indigo-600 to-sky-500 grid place-items-center text-white shadow-md shadow-indigo-500/20 group-hover:scale-105 transition">
              <Briefcase className="w-4.5 h-4.5" size={18} strokeWidth={2.5} />
            </span>
            <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
              Career<span className="text-indigo-700">Connect</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-full transition ${
                    isActive
                      ? "bg-indigo-50 text-indigo-700"
                      : "text-slate-700 hover:text-indigo-700 hover:bg-slate-50"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2">
            <Link to="/admin/login" data-testid="nav-admin-link" className="text-sm font-medium text-slate-500 hover:text-slate-800 px-3 py-2">
              Admin
            </Link>
            <Link to="/enquiry" data-testid="nav-apply-now">
              <Button className="rounded-full bg-gradient-to-r from-blue-700 to-indigo-600 hover:from-blue-800 hover:to-indigo-700 text-white font-semibold px-6 shadow-md shadow-indigo-500/25">
                Apply Now
              </Button>
            </Link>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100"
            onClick={() => setOpen((s) => !s)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4 border-t border-slate-100 pt-3 space-y-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `block px-4 py-2.5 text-sm font-medium rounded-lg ${
                    isActive ? "bg-indigo-50 text-indigo-700" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/admin/login" onClick={() => setOpen(false)} className="block px-4 py-2.5 text-sm text-slate-500">
              Admin Portal
            </Link>
            <Link to="/enquiry" onClick={() => setOpen(false)}>
              <Button data-testid="mobile-apply-now" className="w-full rounded-full bg-gradient-to-r from-blue-700 to-indigo-600 text-white">
                Apply Now
              </Button>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
